import { gql } from '@apollo/client';
import { OrganizationNote } from '../types/organizationNote';
import { OrganizationNoteFieldsFragment } from '../fragments/organizationNote';

export interface UpdateOrganizationNoteRequest {
  id: string;
  content: string;
}

export interface UpdateOrganizationNoteResponse {
  updateOrganizationNote: OrganizationNote;
}

export const UPDATE_ORGANIZATION_NOTE = gql`
  mutation UpdateOrganizationNote($id: String!, $content: String!) {
    updateOrganizationNote(id: $id, content: $content) {
      ...OrganizationNoteFields
    }
  }
  ${OrganizationNoteFieldsFragment}
`;
